import React from "react";
import { Box, CircularProgress, Paper, Typography, alpha, useTheme } from "@mui/material";
import ChatMessage from "./ChatMessage";

const ChatMessages = ({ messages, loading, endRef }) => {
    const theme = useTheme();

    return (
        <Box sx={{
            flexGrow: 1,
            overflowY: "auto",
            p: 2,
            bgcolor: alpha(theme.palette.background.default, 0.5),
            '&::-webkit-scrollbar': { width: '8px' },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: alpha(theme.palette.text.primary, 0.3),
                borderRadius: '4px',
                '&:hover': { backgroundColor: alpha(theme.palette.text.primary, 0.5) }
            },
        }}>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <CircularProgress />
                </Box>
            ) : messages.length > 0 ? (
                messages.map((message, index) => <ChatMessage key={`${message.date}-${index}`} message={message} />)
            ) : (
                <Paper sx={{ textAlign: 'center', py: 5, bgcolor: 'background.paper', color: 'text.secondary' }}>
                    <Typography variant="body1">Сообщений пока нет</Typography>
                    <Typography variant="body2">Будьте первым, кто напишет!</Typography>
                </Paper>
            )}
            <div ref={endRef} />
        </Box>
    );
};

export default ChatMessages;
